module.exports = __webpack_public_path__ + "assets/f9b8f93b994035b849c837a0ee95df89.png";